<template>
  <form class="history-form-container" novalidate @submit.prevent="submit">
    <div class="history-form-item">
      <label for="dateFrom">{{ $t('component.history.filter.labelDateStart') }}:</label>
      <el-date-picker
        v-model="dateFrom"
        type="date"
        size="mini"
        :picker-options="dateFromOptions"
        id="dateFrom">
      </el-date-picker>
      <div class="history-form-item-error" v-if="formError && isDateFromError">
        <ul>
          <li>{{ $t('component.history.filter.errorDateStart') }}</li>
        </ul>
      </div>
    </div>
    <div class="history-form-item">
      <label for="dateTo">{{ $t('component.history.filter.labelDateEnd') }}:</label>
      <el-date-picker
        v-model="dateTo"
        type="date"
        size="mini"
        :picker-options="dateToOptions"
        id="dateTo">
      </el-date-picker>
      <div class="history-form-item-error" v-if="formError && isDateToError">
        <ul>
          <li>{{ $t('component.history.filter.errorDateEnd') }}</li>
        </ul>
      </div>
    </div>
    <div class="history-form-buttons">
      <el-button native-type="submit" size="mini" type="primary">
        {{ $t('component.history.filter.buttonSearch') }}
      </el-button>
    </div>
  </form>
</template>

<script>
import HistoryFilterMixin from '@/common/mixins/History/Filter.mixin'

export default {
  name: 'HistoryFilter',
  mixins: [HistoryFilterMixin]
}
</script>
